import axios from "axios";
import { URL } from "../../config/config";

const BASE = `${URL}/superadmin/checkout-products`;

export const listProducts = (params = {}) =>
  axios.get(BASE, { params }).then((res) => res.data);

// No GET-by-id endpoint exists, so re-read the list and pick the one we want.
export const getProduct = (id) =>
  listProducts().then((list) => (Array.isArray(list) ? list : []).find((p) => p._id === id) || null);

export const createProduct = (body) =>
  axios.post(BASE, body).then((res) => res.data);

export const updateProduct = (id, body) =>
  axios.put(`${BASE}/${id}`, body).then((res) => res.data);

export const addPricingVersion = (id, body) =>
  axios.post(`${BASE}/${id}/pricing`, body).then((res) => res.data);

export const getCheckoutCatalog = () =>
  axios.get(`${BASE}/plan-catalog`).then((res) => res.data);

export const apiErrorMessage = (err, fallback = "Something went wrong") =>
  err?.response?.data?.message || err?.message || fallback;

// Audience picker search. `search` matches _id, contact, email or name/companyName.
export const searchAffiliates = (search = "") =>
  axios
    .get(`${URL}/superadmin/get-affiliates`, {
      params: { rowsPerPage: 20, skip: 0, allFilters: JSON.stringify(search ? { search } : {}) },
    })
    .then((res) => (res.data && res.data.affiliates) || []);
